import { Component, Input } from "@angular/core";
import { NgClass } from "@angular/common";

@Component({
  selector: "onsip-avatar-frame",
  templateUrl: "./avatar-frame.component.html",
  styleUrls: ["./avatar-frame.component.scss"],
  imports: [NgClass]
})
export class AvatarFrameComponent {
  @Input() hasBreakpoints = false;
}
